import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.scss";
import Loader from "./components/common/Loader";
import ApiStateLoader from "./components/common/ApiStateLoader";
import PrivateRoutes from "./utils/PrivateRoutes";

// lazy loaded component
const Customers = lazy(() => import("./components/customers/Customers"));
const CompletedCustomer = lazy(() =>
  import("./components/customers/CompletedCustomer")
);
const CustomerDetails = lazy(() =>
  import("./components/customers/CustomerDetails")
);
const Dashboard = lazy(() => import("./components/dashboard/Dashboard"));
const Login = lazy(() => import("./components/Login"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:customerID" element={<CustomerDetails />} />
            <Route path="completed" element={<CompletedCustomer />} />
          </Route>
          <Route path="sign-in" element={<Login />} />
        </Routes>
      </Suspense>
      <ApiStateLoader />
    </BrowserRouter>
  );
}

export default App;
